module.exports = __webpack_public_path__ + "img/9F9F9F_E4E4E4_D4D4D4_CCCCCC-256px.74872602.png";